import React from 'react';

import { Grid } from '@material-ui/core';

import clsx from 'clsx';
import { OrganogramItem } from './OrganogramItem';
import { OrganogramList } from './OrganogramList';
import { IOrganogramAccordionItemProps, OrganogramAccordion, OrganogramAccordionSummary, organogramAccordionStyles} from '../../../../shared/components/OrganogramAccordion';

export function OrganogramAccordionItem({organogram, textLevel, isParent, level, listOrg}: IOrganogramAccordionItemProps) {
    const classes = organogramAccordionStyles();

    const [expanded, setExpanded] = React.useState<boolean>(false);

    return (
        <Grid
            key={organogram.id}
            item
            xs={12}>
            <OrganogramAccordion
                expanded={expanded}
                key={organogram.id}
                elevation={0}>
                <OrganogramAccordionSummary
                    key={organogram.id}
                    onClick={() => isParent && setExpanded(!expanded)}
                    className={clsx({ [classes.notClickableAccordion]: !isParent })}>
                    <OrganogramItem
                        key={organogram.id}
                        item={organogram} 
                        level={level} 
                        textLevel={textLevel} 
                        isParent={isParent} 
                        expanded={expanded}/>
                </OrganogramAccordionSummary>
                {expanded && <OrganogramList
                    key={organogram.id}
                    listOrg={listOrg} 
                    parent={organogram.id} 
                    level={level + 1} 
                    textLevel={`${textLevel} ${organogram.description} >`} />}
            </OrganogramAccordion>
        </Grid>
    );
}